import { computed, type Ref, type WritableComputedRef } from 'vue'

/*
 * "All" and "nobody" as things a select can actually hold.
 *
 * The select primitives under Nuxt UI (reka-ui) treat an EMPTY STRING as "no value":
 * an item whose value is '' can be shown as the placeholder but cannot be PICKED. So a
 * filter offering { label: 'Vsi vozniki', value: '' } could be set and never cleared,
 * and a driver select offering "Brez voznika" the same way could never unassign anybody.
 *
 * The state these selects drive keeps using '' — it is what the URL query, the API and
 * every comparison in the page already mean by "no filter". Only the select sees the
 * stand-in, through `emptyAs`.
 */
export const EMPTY_OPTION = '__none__'

/** A model for the select: '' in the state is EMPTY_OPTION in the control, and back. */
export const emptyAs = (state: Ref<string>): WritableComputedRef<string> => computed({
    get: () => state.value === '' ? EMPTY_OPTION : state.value,
    set: (value: string) => { state.value = value === EMPTY_OPTION ? '' : value },
})
